<div class="kr-sp-panel-separator" v-show="hasInstallmentSelected || hasPreferredPaymentMethods"><hr></div>